// extracted by mini-css-extract-plugin
module.exports = {"container":"TemplateContent_container__3NHr-"};